import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { create } from "zustand";

import { type User } from "shared-components";
import { isSafeAuthRoute, isStoreManagementRoute } from "@/utils/auth-route";
import { useUserStore } from "./use-user-store";

export interface AuthStore {
  onAuthRoute: string;
  isAuthenticated: boolean;
  hasCheckedAuth: boolean;
  setAuthenticated: (value: boolean, router?: AppRouterInstance, user?: User) => void;
  setOnAuthRoute: (route: string) => void;
  cleanSession: () => void;
}

const initialState = {
  isAuthenticated: false,
  onAuthRoute: "/",
  hasCheckedAuth: false,
};

export const useAuthStore = create<AuthStore>((set, get) => ({
  ...initialState,
  setAuthenticated: (value: boolean, router?: AppRouterInstance, user?: User) => {
    set({ isAuthenticated: value, hasCheckedAuth: true });

    if (user) {
      useUserStore.getState().setUser(user);
    }

    if (value && router) {
      const { onAuthRoute } = get();
      if (isSafeAuthRoute(onAuthRoute) && onAuthRoute !== "/") {
        router.push(onAuthRoute);
      } else if (isStoreManagementRoute(onAuthRoute)) {
        window.open(onAuthRoute, "_blank", "noopener,noreferrer");
        router.push("/");
      } else {
        router.push("/");
      }
      set({ onAuthRoute: "/" });
    }
  },
  setOnAuthRoute: (route: string) => {
    if (route) {
      set({ onAuthRoute: route });
    }
  },
  cleanSession: () => {
    set({ isAuthenticated: false, onAuthRoute: "/", hasCheckedAuth: true });
    useUserStore.getState().reset();
  },
}));
